$(function () {

    if ($('#article').length) {

        $('#blog-article').find('blockquote').addClass('blockquote');

    }

});